import SearchExpanding from './SearchExpanding';

export default SearchExpanding;
